import { Membership, MembershipCriteria, MembershipFormData } from "../types/membership";
import { get, post } from "./fetch.core";

async function create(data: MembershipFormData) {
  sanitizeFormData(data);
  const rst = await post("/admin/membership/create", data);
}

export async function loadMemberships() {
  const rst = await get<Membership[]>("/admin/membership/list");
  return rst.data;
}

async function edit(data: MembershipFormData, id: string) {
  sanitizeFormData(data);
  const rst = await post(`/admin/membership/edit?membershipId=${id}`, data);
}

async function getOne(id: string) {
  const rst = await get<Membership>(`/admin/membership/get?membershipId=${id}`);
  return rst.data;
}

function isoStringToDays(isoDateString: string) {
  const date = new Date(isoDateString);
  const today = new Date();
  const timeDiff = Math.abs(today.getTime() - date.getTime());
  const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
  return dayDiff;
}

async function refreshUserMembership(userId: string) {
  return await get(`/admin/membership/refreshUserMembership?userId=${userId}`);
}

async function getUserCriteria(userId: string) {
  const rst = await get<MembershipCriteria>(`/admin/membership/getUserCriteria?userId=${userId}`);
  return rst.data;
}

async function refreshShopMembership() {
  return await get("/admin/membership/refreshShopMembership");
}

async function refreshAllShopMembership() {
  return await get("/admin/membership/refreshAllShopMembership");
}

async function updateManualExpirationDate(userId: string, membershipId: string, manualExpiration: string) {
  return await post(`/admin/membership/updateManualExpirationDate?userId=${userId}&membershipId=${membershipId}&manualExpiration=${manualExpiration}`, {});
}
async function updateUserMembership(data: { updateType: "activate" | "deactivate"; membershipId: string; userId: string }) {
  return await post(`/admin/membership/updateUserMembership?updateType=${data.updateType}`, data);
}

const membershipPlacementValues = ["online", "pos", "both"] as const;

function sanitizeFormData(data: MembershipFormData) {
  if (data.discountType === "percentage") delete data.discount.amt;
  if (data.discountType === "fixed") delete data.discount.per;
  if (data.issueMode === "auto" && data.autoIssueCriteria) {
    const p = data.autoIssueCriteria.placement;
    if (!membershipPlacementValues.includes(p as (typeof membershipPlacementValues)[number])) {
      data.autoIssueCriteria.placement = "both";
    }
  }

  if (!data.productRestriction?.type || data.productRestriction.type === "none") {
    delete (data as { productRestriction?: unknown }).productRestriction;
  } else if (data.productRestriction.restrictToIds?.length === 0) {
    delete data.productRestriction.restrictToIds;
  }

  if (!data.categoryRestriction?.type || data.categoryRestriction.type === "none") {
    delete (data as { categoryRestriction?: unknown }).categoryRestriction;
  } else if (data.categoryRestriction.restrictToIds?.length === 0) {
    delete data.categoryRestriction.restrictToIds;
  }
}

const membershipCore = {
  loadMemberships,
  create,
  edit,
  getOne,
  isoStringToDays,
  refreshUserMembership,
  getUserCriteria,
  refreshShopMembership,
  refreshAllShopMembership,
  updateUserMembership,
  updateManualExpirationDate,
};

export default membershipCore;
